{
  "register-success-page": {
    "buttons": {
      "start": "Bắt đầu ngay"
    },
    "text": {
      "account-created": "Tài khoản đã được tạo",
      "account-created-hint": "Tài khoản của bạn đã được tạo! Bây giờ bạn có thể đăng nhập và trải nghiệm hệ thống đặt lịch của chúng tôi"
    }
  }
}
